import { render, staticRenderFns } from "./ClientsView.vue?vue&type=template&id=3c3d6e88&scoped=true&"
import script from "./ClientsView.vue?vue&type=script&lang=js&"
export * from "./ClientsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3d6e88",
  null
  
)

export default component.exports